var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDescription({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconography"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8467 4.64667L9.34667 1.15333C9.24667 1.05333 9.14667 1 9 1H4C3.45333 1 3 1.44667 3 2V14C3 14.5533 3.45333 15 4 15H12C12.5533 15 13 14.5533 13 14V5C13 4.85333 12.9467 4.74667 12.8467 4.64667ZM9 2.2L11.8 5H9V2.2ZM12 14H4V2H8V5C8 5.54667 8.45333 6 9 6H12V14Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 11H5V12H11V11Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 8H5V9H11V8Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDescription);
export default __webpack_public_path__ + "static/media/ic-description.607fd1eed6c307971bf7bb80be4558bd.svg";
export { ForwardRef as ReactComponent };